import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { ngxAuthInterceptor, provideDefaultCultures } from '@mds/ngx-auth';
import { acceptLanguageInterceptor, retryInterceptor } from '@mds/ngx-core';
import { provideMdsErrorHandler } from '@mds/ngx-diagnostics';
import { appRoutes } from './app.routes';
import { provideAppInsight } from './factories/app-insights.factory';
import { provideConfiguration } from './factories/configuration.factory';
import { provideDeDateFormat } from './factories/de-date-format.factory';
import { provideForceLightTheme } from './factories/force-lightmode.factory';
import { provideMaterial } from './factories/material.factory';
import { provideMetrics } from './factories/metric.factory';
import { provideNavigationItems } from './factories/navigation-items.factory';
import { provideAuth } from './factories/ngx-auth.factory';
import { provideTitleStrategy } from './factories/title-strategy.factory';
import { provideTranslations } from './factories/translate.factory';
import { responseErrorInterceptor } from './shared/interceptors/response-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withRouterConfig({
        canceledNavigationResolution: 'computed',
      }),
    ),
    provideHttpClient(
      withInterceptors([
        retryInterceptor,
        acceptLanguageInterceptor,
        ngxAuthInterceptor,
        responseErrorInterceptor,
      ]),
    ),
    provideAnimations(),
    provideAppInsight(),
    provideMetrics(),
    provideConfiguration(),
    provideMaterial(),
    provideMdsErrorHandler(),
    provideNavigationItems(),
    provideTranslations(),
    provideDefaultCultures(),
    provideTitleStrategy(),
    provideForceLightTheme(),
    provideDeDateFormat(),
    provideAuth(),
  ],
};
